export const tdis = {
    agencyCode: '009990',
    name: 'Texas Digital Identity Solution',
    shortName: 'TDIS',
    slug: 'tdis',
  };
  